import { cn } from '@/utils/cn';

interface LoadingProps {
  fullscreen?: boolean;
  text?: string;
  className?: string;
}

/**
 * Loading 加载组件
 * @param fullscreen - 是否全屏显示
 * @param text - 加载文本
 * @param className - 自定义样式
 */
export default function Loading({ fullscreen = false, text = '加载中...', className }: LoadingProps) {
  if (fullscreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
        <div className="flex flex-col items-center space-y-4">
          <Spinner size="lg" />
          {text && <p className="text-sm text-text-secondary">{text}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className={cn('flex items-center justify-center py-8', className)}>
      <div className="flex flex-col items-center space-y-2">
        <Spinner />
        {text && <p className="text-sm text-text-secondary">{text}</p>}
      </div>
    </div>
  );
}

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

function Spinner({ size = 'md', className }: SpinnerProps) {
  const sizeClasses = {
    sm: 'w-6 h-6 border-2',
    md: 'w-10 h-10 border-3',
    lg: 'w-16 h-16 border-4',
  };

  return (
    <div
      className={cn(
        'animate-spin rounded-full border-primary border-t-transparent',
        sizeClasses[size],
        className
      )}
    />
  );
}

// 导出 Spinner 以便单独使用
export { Spinner };
